import React, { useEffect, useState } from 'react'
import { Col, Row, Button, Table, Card, ButtonGroup, CardBody, CardHeader, } from 'reactstrap'
import Select from 'react-select'
import MainFilter from '../components/filters/MainFilter'
import { floorRequest, singleSpaceFetch, getEmployeRequest, getSectionofEmpoyeRequest, user, getGraphOfEmployeeActivityRequest } from '../helpers/requests'
import { useDispatch, useSelector } from 'react-redux'
import LettersProfile from '../components/Avatar';
import EmployeLineGraph from "../components/charts/EmployeLineGraph"
import { BarChart, BarChart2, TrendingUp } from 'react-feather'



export default function EmployeActivity() {

    const [activeButton, setActiveButton] = useState({
        label: "Employee",
        value: "employee"
    })
    const [filter, setFilter] = useState();

    const [dataToShow, setDataToShow] = useState([])
    const [requestFlag, setRequestFlag] = useState(true)
    const dispatch = useDispatch();
    const floors = useSelector((state) => state.floorReducer.floors)
    const [sections, setSections] = useState([])
    const employees = useSelector((state) => state.floorReducer.employee);
    const graph = useSelector((state) => state.employeActivity.graphOfEmploye)
    const [currentEmploye, setCurrentEmploye] = useState()
    const [sectionId, setSectionId] = useState()
    const graphLoader = useSelector((state) => state.employeActivity.graphLoader);
    const sectionOfEmploye = useSelector((state) => state.employeActivity.sectionOfEmploye);
    const [seriesData, setSeriesData] = useState([]);
    const mainLoader = useSelector((state) => state.highlights.loading)
    const [totalMinutes, setTotalMinutes] = useState(0)
    const [type, setType] = useState('bar')



    // const sectionOf = useSelector((state) => state)
    // const sectionOfEmploye = []
    const [employe, setEmploye] = useState([])
    const activity = [
        {
            label: "Employee",
            value: "employee"
        },
        {
            label: "Section",
            value: "section"
        }
    ]

    const summaryMenu = [
        // ["line", <TrendingUp size={16} />],
        ["bar", <BarChart2 size={16} />],
    ];


    const updateFilter = (e) => {
        setFilter(e)
        console.log('dfdfd', e);
        setRequestFlag(true)

        // setFilter(e);
        // var requestData = {
        //     params: e,
        //     dispatch
        // }

    }
    const customStyles = {
        option: (provided, state) => ({
            ...provided,
            background: state.isSelected ? "#fd7e14" : '',
            boxShadow: "0px 4px 37px 9px rgb(0 0 0 / 3%)",
            borderRadius: "0px",
        }),
        control: (provided) => ({
            ...provided,
            height: "40px",
            background: "#FFFFFF",
            boxShadow: "0px 4px 37px 9px rgb(0 0 0 / 3%)",
            borderRadius: "4px",
            border: "1px solid  #ced4da",
            width: 150,

        }),
        menu: (provided) => ({
            ...provided,
            zIndex: 10
        })
    }
    const customStylesTwo = {
        option: (provided, state) => ({
            ...provided,
            background: state.isSelected ? "#fd7e14" : '',
            boxShadow: "0px 4px 37px 9px rgb(0 0 0 / 3%)",
            borderRadius: "0px",
        }),
        control: (provided) => ({
            ...provided,
            height: "40px",
            background: "#FFFFFF",
            boxShadow: "0px 4px 37px 9px rgb(0 0 0 / 3%)",
            borderRadius: "4px",
            border: "1px solid  #ced4da",
            width: 230,
            margin: "0 25px"

        }),
        menu: (provided) => ({
            ...provided,
            zIndex: 10
        })
    }

    const search = () => {
        if (activeButton.value === 'employee') {
            let params = {
                start: filter.start,
                end: filter.end,
                type: "emp",
                emp_id: currentEmploye?.value,
                dispatch
            }
            getGraphOfEmployeeActivityRequest(params);

            getSectionofEmpoyeRequest(params)
        }
        if (activeButton.value === "section") {
            let params = {
                start: filter.start,
                end: filter.end,
                type: "sec",
                sec_id: sectionId?.value,
                dispatch
            }
            getGraphOfEmployeeActivityRequest(params);
            getSectionofEmpoyeRequest(params)
        }


    }



    // const requestByemployee = () => {

    // }

    // const requestBySection = () => {

    // }

    useEffect(() => {
        if (employees) {
            setCurrentEmploye({ label: employees[0]?.name, value: employees[0]?._id })
        }
    }, [employees])


    useEffect(() => {
        if (employees) {
            let _employe = [];
            employees.map((item) => {
                _employe.push({
                    value: item._id,
                    label: item.name
                })
            })
            setEmploye(_employe);
        }

    }, [employees])

    useEffect(() => {
        if (floors) {
            let sections = [];
            floors.map((item) => {
                item.sections.map((section) => {
                    sections.push({
                        value: section._id,
                        label: section.label

                    })
                })
            })
            setSections(sections);
        }
    }, [floors])

    useEffect(() => {
        if (filter) {
            let obj = {
                _id: filter.sid,
                dispatch
            }
            floorRequest(obj)
            getEmployeRequest({ _id: filter?.sid, dispatch })

        }


    }, [filter])


    useEffect(() => {
        if (sections.length && dataToShow.length) {

            let sec = sections.map((item) => {
                return item.value
            })

            let totalMinutes = 0 ;
            let total_time_spent_by_employee = dataToShow?.map((item) => {
                totalMinutes = totalMinutes + item.minutes

            } 

            )
            setTotalMinutes(totalMinutes.toFixed());
            console.log('totalMinutes',totalMinutes.toFixed());


            console.log('total_time_spent_by_employee',total_time_spent_by_employee);
            let valueNotExisted = dataToShow?.filter((data) => !sec.includes(data.sec_id))
            console.log('valueNotExisted', valueNotExisted);
        }

    }, [sections, dataToShow])





    useEffect(() => {

        if (requestFlag === true) {

            if (Object.keys(currentEmploye ? currentEmploye : {}).length) {
                if (typeof currentEmploye?.value === "string") {

                    let params = {
                        start: filter.start,
                        end: filter.end,
                        type: "emp",
                        emp_id: currentEmploye?.value,
                        dispatch
                    }

                    getSectionofEmpoyeRequest(params)
                    getGraphOfEmployeeActivityRequest(params);
                    setRequestFlag(false)

                }

            }
        }

    }, [currentEmploye, requestFlag])


    useEffect(() => {

        let _dataToShow = sectionOfEmploye?.filter((employee) => {
            return employee.sec_id != "0"
        })
        console.log('_dataToShow_dataToShow', _dataToShow);


        setDataToShow(_dataToShow)

    }, [sectionOfEmploye])


    useEffect(() => {
        setDataToShow([]);
        setSeriesData([]);
    }, [activeButton])

    useEffect(() => {


        if (graph) {
            var seriesData = [];
            // console.log('graph',graph);
            graph.map((item) => {

                if (activeButton.value === 'section') {

                    let obj = {
                        stack: false,
                        name: item?.employee.name,
                        data: item?.array,
                        type: type
                    }
                    seriesData.push(obj);
                }
                else if (activeButton.value === "employee") {
                    let section = sections.filter((sec) => {
                        return sec.value === item.sec_id
                    })[0]


                    let obj = {
                        stack: false,
                        name: section?.label,
                        data: item?.array,
                        type: type
                    }
                    seriesData.push(obj);

                }
            })
            setSeriesData(seriesData);
        }

    }, [graph])


    useEffect(() => {
        if (graph) {
            var seriesData = [];
            // console.log('graph',graph);
            graph.map((item) => {
                if (activeButton.value === 'section') {
                    let obj = {
                        stack: false,
                        name: item?.employee.name,
                        data: item?.array,
                        type: type
                    }
                    seriesData.push(obj);
                }
                else if (activeButton.value === "employee") {
                    let section = sections.filter((sec) => {
                        return sec.value === item.sec_id
                    })[0]
                    let obj = {
                        stack: false,
                        name: section?.label,
                        data: item?.array,
                        type: type
                    }
                    seriesData.push(obj);
                }
            })
            setSeriesData(seriesData);
        }
    }, [type])




    console.log('dataToShow', dataToShow);




    return (
        <div>
            <MainFilter pageTitle="Employee Activity" updateFilter={(e) => updateFilter(e)} type='silver' />
            <Row>
                <Col className='d-flex flex-row' >
                    <Select
                        value={activeButton}
                        options={activity}
                        styles={customStyles}
                        onChange={(event) => setActiveButton(event)}
                    />


                    {activeButton.value === 'employee' && employe &&
                        <Select
                            options={employe}
                            value={currentEmploye}
                            styles={customStylesTwo}
                            placeholder="Employee"
                            onChange={(e) => setCurrentEmploye(e)}
                        />
                    }

                    {
                        activeButton.value === "section" && sections &&
                        <Select
                            value={sectionId}
                            options={sections}
                            styles={customStylesTwo}
                            placeholder="Section"
                            onChange={(value) => setSectionId(value)}
                        />

                    }

                    {(activeButton.value === "employee" || activeButton.value === "section") && <Button className='' color='outline-primary' disabled={!activeButton} onClick={search}>Search</Button>}

                    {/* <Button className={activeButton === "employee" ? "btn btn-primary " : ''} onClick={() => setActiveButton("employee")}>By employee</Button>
                    <Button className={activeButton === "section" ? "btn btn-primary mx-3" : 'mx-3'} onClick={() => setActiveButton("section")}>By Section</Button> */}

                </Col>

            </Row>
            <Row className='my-4'>
                <Col className='d-flex flex-row'>
                    {/* {activeButton === 'employee' && employe &&
                        <Select
                            options={employe}
                            styles={customStyles}
                            placeholder="Employee"
                        />
                    }
                    {
                        activeButton === "section" && sections &&
                        <Select
                            options={sections}
                            styles={customStyles}
                            placeholder="Section"
                        />

                    }
                    {(activeButton === "employee" || activeButton === "section") && <Button className='mx-3' >Search</Button>} */}

                </Col>
            </Row>
            <Row>
                <Col>
                    <Card className="" style={{ backgroundColor: '', overflow: '' }}>
                        {

                            <CardHeader>
                                <Row>
                                    <Col md={4}>
                                        <h4 className="m-0 p-2" style={{ fontSize: '14px' }}>{activeButton.value === "employee" ? "Employee" : "Section"}  {type} Graph</h4>
                                    </Col>
                                    <Col classNmdame={8} className="text-end">
                                        <ButtonGroup>
                                            {
                                                summaryMenu.map((val, index) => {
                                                    return (
                                                        <Button
                                                            href={"#toggle-tab-" + val[0]}
                                                            color={type == val[0] ? "outline-primary" : "outline-light"}
                                                            className='section-tab'
                                                            size='sm'
                                                            onClick={() => setType(val[0])}
                                                            active={type == val[0] ? true : null}
                                                            key={"compare-tab-" + index}
                                                        >
                                                            {val[1]}
                                                        </Button>
                                                    );
                                                })
                                            }
                                        </ButtonGroup>
                                    </Col>
                                </Row>
                            </CardHeader>
                        }
                        <CardBody style={{ minHeight: '6.75rem', height: '13rem', backgroundColor: '' }}>
                            {seriesData.length > 0 && graphLoader && <EmployeLineGraph legends={''} seriesData={seriesData} />}
                            {graphLoader && !mainLoader && !seriesData.length && <span className='className="d-block small opacity-50"'><i>no data on selected date please select another date for linegraph</i></span>}
                            <div className="container h-100">
                                <div className="row align-items-center h-100">
                                    <div className="col-6 mx-auto">
                                        <div className="jumbotron">
                                            {!graphLoader && <span className="d-block small opacity-30 text-center align-middle "><i>Data Fetching...</i></span>}
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </CardBody>
                    </Card>
                </Col>


            </Row>
            <Row className='my-4'>
                <Col>
                    <Table bordered style={{ fontSize: "14px", textAlign: "center" }}>
                        <thead>
                            <tr>
                                <th>{activeButton.value === "employee" ? "Section" : "Employee"}</th>
                                <th>Minutes</th>
                                <th>Percentage</th>
                                { activeButton.value === "employee" &&<th>Monitored Percentage</th>}
                                <th>Units</th>
                                <th>Transaction</th>
                                <th>Sales</th>
                                <th>Conversion</th>
                                <th>IPT</th>
                                <th>ASP</th>
                                <th>ATV</th>
                                <th>Traffic</th>
                            </tr>
                        </thead>
                        <tbody>
                            {dataToShow?.map((item, index) => (
                                <tr key={index}>
                                    {
                                        activeButton.value === "employee" &&
                                        <>
                                            <td>

                                                {
                                                    sections?.map((section, index1) => {
                                                        if (section.value === item.sec_id) {
                                                            return section.label
                                                        }
                                                        else {
                                                            if (user.name != "Saphhire") {
                                                                if (index1 === 0 && index === 0) {
                                                                    return "Kids"
                                                                }
                                                                if (index1 === 1 && index === 1) {
                                                                    return "Unstitched"
                                                                }
                                                                if (index1 === 2 && index === 2) {
                                                                    return "Stitched"
                                                                }
                                                                if (index1 === 3 && index === 3) {
                                                                    return "Top Right Corner"
                                                                }
                                                                if (index1 === 4 && index === 4) {
                                                                    return "Left Corner"
                                                                }
                                                               


                                                            }


                                                        }
                                                    })

                                                }

                                            </td>
                                            <td>{item.minutes?.toFixed()}</td>
                                            <td>{((item?.minutes / 600) * 100).toFixed(2)}%</td>
                                            <td>{((item.minutes?.toFixed() /totalMinutes)*100).toFixed(2)}%</td>
                                            <td>{item.units?.toFixed(0)}</td>
                                            <td>{item.transaction?.toFixed(0)}</td>
                                            <td>{item?.sale?.toFixed(0)}</td>
                                            <td>{item?.conversion?.toFixed(0)}</td>
                                            <td>{item.ipt.toFixed(0)}</td>
                                            <td>{item.asp.toFixed(0)}</td>
                                            <td>{item.atv.toFixed(0)}</td>
                                            <td>{item.traffic.toFixed(0)}</td>
                                        </>

                                    }
                                    {
                                        activeButton.value === "section" &&

                                        <>
                                            <td>

                                                {employees.map((emp) => {
                                                    if (emp.id === item.emp_id) {
                                                        return <Row>
                                                            <Col md={2}>
                                                                {emp.image && <img style={{ borderRadius: '50%', overflow: 'hidden', width: '40px', height: '40px' }} className="mx-2" src={emp.image}  ></img>}

                                                                {!emp.image && <div className='mx-2'><LettersProfile name={emp.name} /></div>}
                                                            </Col>
                                                            {/* <Col md={1}></Col> */}
                                                            <Col md={9} className='py-2 mx-2' style={{ textAlign: "left" }}>
                                                                {emp.name}

                                                            </Col>
                                                        </Row>

                                                    }
                                                })}
                                            </td>
                                            {

                                                <>
                                                    <td>{item?.minutes?.toFixed(0)}</td>
                                                    <td>{((item?.minutes / 600) * 100).toFixed(0)}%</td>
                                                    <td>{item.units.toFixed(0)}</td>
                                                    <td>{item.transaction.toFixed(0)}</td>
                                                    <td>{item?.sale?.toFixed(0)}</td>
                                                    <td>{item?.conversion?.toFixed(0)}</td>
                                                    <td>{item.ipt.toFixed(0)}</td>
                                                    <td>{item.asp.toFixed(0)}</td>
                                                    <td>{item.atv.toFixed(0)}</td>
                                                    <td>{item.traffic.toFixed(0)}</td>
                                                </>

                                            }
                                        </>
                                    }
                                </tr>
                            ))}

                        </tbody>
                    </Table>

                </Col>
            </Row>

        </div>
    )
}
